module.exports = __webpack_public_path__ + "img/p2_title.79115932.png";